<template>
  <div v-loading="TokenVolumeLoading">

     <el-row>
      <el-col>
        <div class="navBox">
          <p class="miniTitle">{{$t(`home.currencyName`)}}</p>
          <p class="miniTitle">{{$t(`home.activeAddress`)}}</p>
         
        </div>
        <!-- ----------手风琴------------------ -->
        <el-collapse style="min-height:600px" accordion @change="handelChang" v-model="activeNames">
          <el-collapse-item
            v-for="(item, index) in dataCount"
            :key="index"
            @click.native="handelClick(item.abbr,item.id,index)"
           
          >
            <template slot="title">
              <div class="accordion">
                <span class="currencyBox">
                  <!-- 拿到item.param的值 -->
                  <span>{{ item.abbr }}</span>
                </span>
                <span>                 
                  {{ item.address }}
                </span>
              </div>
            </template>

            <div :id="'echarts' + item.id" class="DropDownChart" v-loading="chartLoading"></div>
         
          </el-collapse-item>
        </el-collapse>
      </el-col>
    </el-row>


    <!-- <el-row>
      <el-col :span="24">
        <div
          id="TokenVolume"
          style="width: 100%; min-height: 700px"
        ></div>
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
import indeJs from "./index";
export default {
  mixins: [indeJs],
};
</script>

<style lang="scss" scoped>
.main {
  height: 100vh;
}
.navBox {
  // background: gold;
  width: 100%;
  height: 60px;
  // line-height: 60px;
  display: flex;
  justify-content: space-around;
  background: rgba(247, 147, 27, 0.1);
  .miniTitle{
    // background: gold;
    font-weight: 600;

  }
}

.navBox span {
  display: inline-block;

  width: 100px;

    // outline: 1px solid red;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
}
.accordion {
  display: flex;
  position: relative;
  // outline: 1px solid green;
  // background: gold;
  width: 100%;
  height: 100%;
  // height: 100px;

  justify-content: space-around;
}
.conent {
  height: 100px;
  // background: darkmagenta;
}
.accordion > span {
  // outline: 1px solid red;
  //  background: gold;
  width: calc(100% / 4);
  text-align: center;
  // line-height: 100px;
  font-weight: 600;
}
// ------------交易对样式----------------------------
.currencyBox {
  // outline: 1px solid red;
  position: relative;
  // background: greenyellow;
}
.img {
  width: 25px;
  // outline: 1px solid red;
  position: absolute;
  left: 145px;
  top: 36px;
  bottom: 0;
}
.currencyBox > span {
  position: absolute;
  // outline: 1px solid red;
  height: 100%;
  left: 180px;
  top: 0px;

  // bottom: 0;
  font-weight: 600;
}
.chart {
  // position: absolute;
  // top: 10px;
  // right: 50px;
}
// -----------------------------

.DropDownChart {
  // width: 110%;
  // height: 600px;
  // outline: 1px solid red;
  width: 100%;
  height: 700px;
  // margin-left: 30px;

  // outline: 1px solid red;
  // padding: 50px 0px;
}

</style>
<style  lang="scss">